import Flags from './flags-min.png';

export default Flags;
